import { Routes } from '@angular/router';
import { v2On } from '../v2/ui-v2.guard';

export const scheduleRoutes: Routes = [
  {
    path: 'schedule',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/calendar/schedule-v2.page').then(m => m.ScheduleV2Page)
  },
  {
    path: 'schedule',
    loadComponent: () => import('./schedule.page').then(m => m.SchedulePage)
  }
];
